// CANONICAL COPY (GH #7115). src/constants/obligations/obl-offboarding-access.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-offboarding-access',
  title: 'Verify leaver access revocation',
  description:
    'Confirm that all departing employees have had their system access revoked promptly. Check JML leaver checklists.',
  category: 'people',
  scfIds: ['SCF-PPL-005'],
  cadence: { frequency: '3m', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'employees-access-revoked',
      description: 'All leavers have access-revoked in JML checklist',
    },
    {
      type: 'jml-process-complete',
      jmlType: 'leave',
      description: 'All leaver JML processes are completed',
    },
  ],
  domainActions: [{ type: 'deep-link', target: 'employees', label: 'Review Employee Records' }],
};
